module.exports = __webpack_public_path__ + "img/planDeMasseDef.9306da78.png";